<template lang="pug">
	.radio-tab.justify
		.radio-tab-widgets(v-if="data && !isLoading")
			.widget.flex-col.padded
				span.name.black-on-white {{$tCaption('Campaign metrics')}}
				DxDataGrid.compact(width="100%", :data-source="data.CampaignMetrics", :show-borders="true", :column-hiding-enabled="true", :allowColumnResizing="true", columnResizingMode="widget")
					DxColumn(data-field="Market", :caption="$tCaption('Market')")
					DxColumn(:caption="$tCaption('Spots')")
						DxColumn(data-field="SpotsOrdered", :caption="$tCaption('Ordered')", format="fixedPoint")
						DxColumn(data-field="SpotsAired", :caption="$tCaption('Aired')", format="fixedPoint")
						DxColumn(data-field="SpotsCompilance", :caption="$tCaption('Compilance')", format="0#.#%")
					DxColumn(:caption="$tCaption('GRPS')")
						DxColumn(data-field="GrpsOrdered", :caption="$tCaption('Ordered')", format="fixedPoint")
						DxColumn(data-field="GrpsAired", :caption="$tCaption('Aired')", format="fixedPoint")
						DxColumn(data-field="GrpsCompilance", :caption="$tCaption('Compilance')", format="0#.#%")
					DxColumn(:caption="$tCaption('Impressions')")
						DxColumn(data-field="ImpressionsOrdered", :caption="$tCaption('Ordered')", format="fixedPoint")
						DxColumn(data-field="ImpressionsAired", :caption="$tCaption('Aired')", format="fixedPoint")
						DxColumn(data-field="ImpressionsCompilance", :caption="$tCaption('Compilance')", format="0#.#%")
					DxPaging(:page-size="10")
			.widget.flex-row
				.flex-col.padded
					span.name.black-on-white {{$tCaption('Spots')}}
					DxPieChart(:data-source="pieChartData",
						resolve-label-overlapping="shift",
						type="doughnut",
						:size="{ height: 280, width: 280 }",
						:series="[pieChartSerieConfig()]",
						:legend="{ visible: false }",
						:inner-radius="0.65",
						palette="Soft Pastel",
						center-template="centerTemplate"
					)
						DxTooltip(:enabled="true", :zIndex="100000", format="fixedPoint", :customizeTooltip="(e) => ({ text: `${e.valueText}\n${e.argument}` })")
						template(v-slot:centerTemplate="center")
							svg
								text(text-anchor="middle"
									x="100"
									y="120"
								)
									tspan(:style="{fontSize: 50, fontName: 'Roboto', fontWeight: 100, fill: '#333', letterSpacing: '-4px' }", x="100") {{max(pieChartData, 'value').percent}}%
									tspan(:style="{fontSize: 20, fontName: 'Roboto', fontWeight: 100, fill: '#333' }", x="100", dy="20px") {{max(pieChartData, 'value').name}}
				.flex-col.justify
					span.name.black-on-white {{$tCaption('Campaign spots')}}
					DxChart.spots-chart(:data-source="data.CampaignSpots", :size="{ height: 280, width: 'auto' }", :palette="palette",
						:zoomAndPan="{ argumentAxis: 'both', valueAxis: 'none' }",
						:scrollBar="{ visible: true, position: 'bottom', width: 5 }"
					)
						DxSeries(value-field="ScheduledSpotsCount", :name="$tCaption('Scheduled')")
						DxSeries(value-field="AiredSpotsCount", :name="$tCaption('Aired')")
						DxLegend(:visible="true")
						DxCommonSeriesSettings(type="bar", argument-field="Date", :ignoreEmptyPoints="true")
						DxTooltip(:enabled="true", :zIndex="100000", format="fixedPoint", :customizeTooltip="customizeCampaignSpotsTooltip")
						DxValueAxis(:visible="true", :title="{ text: $tCaption('Spots count') }", color="#dedede", :grid="{ color: '#efefef' }", :tick="{ color: '#00000000' }", :label="{ font: { color: '#333' }}")
						DxArgumentAxis(:visible="true", type="discrete", argumentType="datetime", color="#efefef", :grid="{ color: '#efefef' }", :tick="{ color: '#00000000' }",
							:label="{ textOverflow: 'Ellipsis', overlappingBehavior: 'rotate', rotationAngle: 30, format: 'MM/dd/yyyy', font: { color: '#333' }}")
				.flex-col.padded.last-played.black-on-white
					span.time(v-if="data.LastPlayedSpot.PlayedDateTime") {{$tCaption('Last played')}} {{lastPlayedTime()}}
					span.time(v-else) {{$tCaption('Not played yet')}}
					span.station {{data.LastPlayedSpot.Station || data.LastPlayedSpot.Title}}
					span.account {{data.LastPlayedSpot.AccountName}}
			.widget.flex-col
				span.name.black-on-white {{$tCaption('Play log')}}
				DxDataGrid.compact(width="100%", :data-source="data.Schedule", :show-borders="true", :column-hiding-enabled="true", :allowColumnResizing="true", columnResizingMode="widget")
					DxColumn(data-field="Station", :caption="$tCaption('Station')")
					DxColumn(data-field="Title", :caption="$tCaption('Title')")
					DxColumn(data-field="ISCI", :caption="$tCaption('ISCI')", cssClass="no-padding", cell-template="isci-cell-template", :width="audioColumnWidth")
					DxColumn(data-field="Material", :caption="$tCaption('Air check')", cssClass="no-padding", cell-template="aircheck-cell-template", :width="audioColumnWidth")
					DxColumn(data-field="PlayTime", :caption="$tCaption('Play time')", dataType="date", format="shortDateShortTime")
					DxColumn(data-field="Duration", :caption="$tCaption('Duration')")
					DxColumn(data-field="Status", :caption="$tCaption('Status')")
					DxPaging(:page-size="10")
					template(v-slot:aircheck-cell-template="{ data }")
						PlayButton(v-if="data.data.AirCheckLink", :playingCaption="data.data.Title", :caption="$tCaption('Air check')", @change="v => playInPlayer(data.data, v, 'AirCheckLink')", :playState="bottomPlayer.fieldName === 'AirCheckLink' && bottomPlayer.playState && data.data.AirCheckLink == bottomPlayer.audioLink")
					template(v-slot:isci-cell-template="{ data }")
						PlayButton(v-if="data.data.ISCILink", :playingCaption="data.data.Title", :caption="$tCaption('ISCI')", @change="v => playInPlayer(data.data, v, 'ISCILink')", :playState="bottomPlayer.fieldName === 'ISCILink' && bottomPlayer.playState && data.data.ISCILink == bottomPlayer.audioLink")
		.widget(v-if="isLoading")
			.loading.flex-row.space.black-on-white
				.loader
					i.fas.fa-circle-notch.fa-spin
				span {{$tCaption('Loading')}}..
		BottomAudioPlayer(:visible="bottomPlayer.isInitiated",
			:src="bottomPlayer.audioLink",
			:playState="bottomPlayer.playState",
			:fileName="bottomPlayer.fileName",
			:title="bottomPlayer.title",
			:duration="bottomPlayer.duration",
			@isPlaying="v => bottomPlayer.playState = v",
			@hide="hideBottomPlayer")
</template>

<script>
	import VueTypes from 'vue-types';
	import Data from 'app-core/Data';
	import {DxChart, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat} from 'devextreme-vue/chart';
	import {DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem} from 'devextreme-vue/data-grid';
	import DxPieChart from 'devextreme-vue/pie-chart';
	import BottomAudioPlayer from 'view/audioPlayer/BottomAudioPlayer.vue';
	import moment from 'moment';
	import PlayButton from 'view/audioPlayer/PlayButton.vue';

	export default {
		translationCategory: 'dashboard.RadioTab',
		name: 'radio-tab',
		components: {
			DxChart, DxPaging, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat,
			DxDataGrid, DxColumn, DxSelection, DxSummary, DxTotalItem,
			DxPieChart,
			BottomAudioPlayer,
			PlayButton
		},
		props: {
			trafficCampaignId: VueTypes.any.def(null)
		},
		data() {
			return {
				radioSchedule: [],
				audioColumnWidth: 120,
				data: null,
				isLoading: false,
				palette: ['#d1d1d1', '#4aa97d'],
				bottomPlayer: {
					isInitiated: false,
					playState: false,
					audioLink: null,
					fileName: null,
					title: null,
					duration: null,
					fieldName: null
				}
			};
		},
		computed: {
			pieChartData() {
				return !this.data ? [] : [{ name: this.$tCaption('Aired'), value: this.data.SpotsAired }, { name: this.$tCaption('Scheduled'), value: this.data.SpotsNotAired }];
			}
		},
		watch: {
			trafficCampaignId() {
				this.loadData();
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			hideBottomPlayer() {
				this.bottomPlayer = {
					isInitiated: false,
					playState: false,
					audioLink: null,
					fileName: null,
					title: null,
					duration: null
				};
			},
			lastPlayedTime() {
				return moment(this.data.LastPlayedSpot.PlayedDateTime).fromNow();
			},
			customizeCampaignSpotsTooltip(e) {
				return {
					text: `${e.valueText} ${e.seriesName}\n${moment(e.argument).format('l')}`
				};
			},
			max(source, prop) {
				var item = _.maxBy(source, prop) || {};
				var total = _.sumBy(source, prop) || 0;
				if (!total) return 0;
				return {...item, percent: Math.floor(parseFloat(item[prop] * 100) / total) || 0};
			},
			loadData() {
				if (__DEBUG__)
					console.info('Load radio tab data');
				if (this.trafficCampaignId) {
					this.isLoading = true;
					Data.callMethod('trafficCampaignRadioData', { trafficCampaignId: this.trafficCampaignId })
						.then(rslt => {
							if (__DEBUG__)
								console.info('Radio data loaded', rslt);
							this.data = rslt;
							if (this.data.CampaignMetrics) {
								this.data.CampaignMetrics = this.data.CampaignMetrics.map(f => ({
									...f,
									SpotsCompilance: f.SpotsAired/f.SpotsOrdered || 0,
									GrpsCompilance: f.GrpsAired/f.GrpsOrdered || 0,
									ImpressionsCompilance: f.ImpressionsAired/f.ImpressionsOrdered || 0,
								}));
							}
						})
						.finally(() => this.isLoading = false);
				}
			},
			pieChartSerieConfig() {
				return {
					argumentField: 'name',
					valueField: 'value',
					label: {
						visible: false,
						backgroundColor: 'none',
						format: 'fixedPoint',
						connector: {
							visible: true
						},
						customizeText: ({ argumentText }) => `${argumentText}`
					}
				};
			},
			playInPlayer(data, playState, fieldName) {
				if (__DEBUG__)
					console.info('Play in bottom player', { data, playState, bottomPlayer: this.bottomPlayer });

				if (this.bottomPlayer.fieldName !== fieldName || this.bottomPlayer.audioLink !== data[fieldName])
					this.bottomPlayer.audioLink = null;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.bottomPlayer.isInitiated = true;
					this.bottomPlayer.audioLink = data[fieldName];
					this.bottomPlayer.title = data.Title;
					this.bottomPlayer.fileName = data.FileName;
					this.bottomPlayer.playState = playState;
					this.bottomPlayer.duration = data.Duration;
					this.bottomPlayer.fieldName = fieldName;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.radio-tab {
		.padded {
			padding: 10px;
		}

		.last-played {
			width: 300px;
			justify-content: center;
			align-items: center;
			background: rgba(0,0,0,0.02);
			border-radius: 4px;

			.time {
				font-size: 16px;
			}

			.station {
				font-size: 22px;
				text-transform: uppercase;
				text-align: center;
			}

			.account {
				font-size: 14px;
			}
		}

		.spots-chart {
			width: calc(50vw - 100px);
			min-width: 400px;
		}
	}
</style>
